// Drop-in replacement for ReactToPrint component that uses html2pdf
// Usage: Replace `import ReactToPrint from 'react-to-print'`
//        with `import ReactToPrint from '../../Shared/print/ReactToPrint'`

import React from 'react';
import { useReactToPrint } from './useHtml2PdfPrint';

const ReactToPrint = ({ trigger, content, onBeforeGetContent, onAfterPrint, pageStyle, documentTitle, removeAfterPrint }) => {
  const handlePrint = useReactToPrint({
    content,
    onBeforeGetContent,
    onAfterPrint,
    pageStyle,
    documentTitle,
    removeAfterPrint,
  });

  const attachHandler = (element) => {
    if (!React.isValidElement(element)) return element;
    const existingOnClick = element.props?.onClick;
    const handleClick = (event) => {
      if (typeof existingOnClick === 'function') {
        existingOnClick(event);
      }
      handlePrint(event);
    };
    return React.cloneElement(element, { onClick: handleClick });
  };

  if (typeof trigger === 'function') {
    const triggerElement = trigger(handlePrint);
    return attachHandler(triggerElement);
  }

  return attachHandler(trigger);
};

export default ReactToPrint;
